import { Injectable } from '@angular/core';
import { DatasourceJobSettingsValidationService } from '@y42/datasource';
import { UiModelingStoreModel } from '../../datasource/ui-modeling.model';

@Injectable({ providedIn: 'root' })
export class UiModelingJobSettingsValidationService extends DatasourceJobSettingsValidationService<UiModelingStoreModel> {}
